import { defineMessages } from "react-intl";

const baseId = "t.components.modals.errorModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "UNKNOWN ERROR",
  },

  simpleErrorMessage: {
    id: baseId + "simpleErrorMessage",
    defaultMessage: "An error has occurred, please go to home",
  },

  ctaGoBack: {
    id: baseId + "ctaGoBack",
    defaultMessage: "BACK",
  },

  ctaGoToWelcome: {
    id: baseId + "ctaGoToWelcome",
    defaultMessage: "GO TO WELCOME",
  },
});
